import { useTableMetadataStore } from "../../_stores"
import { useRef } from "react";
import constants from "./constants"
import DropdownCell from "./_DropdownCell"
import Cell from './_Cell';

function TableCell({ data, index }, ref) {
	if (!ref) ref = useRef(null)
	// get the type of the column
	const column = useTableMetadataStore(state => state.columns)[index]
	if (!column) return null

	if (column.type === constants.PLAIN_TEXT) {
		return (
			<Cell
				column={column}
				data={data}
				ref={ref}
			/>
		)
	}

	if (column.type === constants.DROPDOWN) {
		return (
			<DropdownCell data={data} column={column} ref={ref} ></DropdownCell>
		)
	}

	if (column.type === constants.LINK) {
		return (
			<Cell data={data} column={column} ref={ref} isLink={true}></Cell>
		)
	}

	return <Cell
		column={column}
		data={data}
		ref={ref}
		isEditable={false}
	/>
}

export default React.forwardRef(TableCell)